module.exports = __webpack_public_path__ + "6ddf9b95e5d6292e512def54dc2bad7d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!../data/target.png
 ** module id = 21
 ** module chunks = 0
 **/